/**
 * 证书管理
 *
 * Author:   gsm(qq:2479186745)
 * History:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2023/3/8      1.0     First version
 *
 * Copyright 2016, all rights reserved. Essa.cn
 * */


 import React from "react"
 import Lang from "@components/Lang/Lang";
 import {Checkbox, Spin,  Button,Popover, Space } from 'antd'
 import './index.less'
 import AutoFetchTable from "@/components/AutoFetchTable/AutoFetchTable";
 import CertificateForm from "./CertificateForm";
 import CommonBreadcrumb from "@components/CommonBreadcrumb"
 import AuthBtn from "@components/HoverIcon/AuthBtn";
 import PageCommon from  "@components/PageCommon/PageCommon";
 import dayjs from "dayjs";
 
 class CertificateMgr extends React.Component {
     constructor(props) {
         super(props)
         
         this.state = {
            loading:false,
            isExpired:0,
            searchFormOptions:[
                {
                    name:'keyword',
                    cnTitle:'',
                    cnTitleId:'',
                    cnPlaceholder:'搜索证书编号或备注',
                    cnPlaceholderId:'SouSuoZhengShuBianHaoHuoBeiZhu',
                    type:'SearchInput',
                    width:400,
                },
            ],
            columns:[
                {
                    cnTitle: '证书',
                    dataIndex: 'code',
                    cnTitleId: 'ZhengShu',
                    render: (buyerCode, record) => {
                        return(<div>
                            {
                                <b>{record.code}</b>
                            }
                        </div>)}
                },
                {
                    cnTitle: '适用类目',
                    dataIndex: 'ShiYongLeiMu',
                    cnTitleId: 'ShiYongLeiMu',
                    render: (buyerCode, record) => {
                        return(<div>
                            {
                                record.categoryList && record.categoryList.map((item,index) => {
                                    return <span> {index === 0?'':','} {item.categoryName} </span>
                                })
                            }
                        </div>)}
                },
                {
                    cnTitle: '有效期',
                    dataIndex: 'effectiveBeginTime',
                    cnTitleId: 'YouXiaoQi',
                    width:'200px',
                    render: (preLoadDate, record) =>{
                        return (<div>
                            <span style={{color: record.isExpired?'#E6521F':'rgba(0,0,0,0.66)'}}>
                                {record.effectiveBeginTime?(dayjs(record.effectiveBeginTime).format('MM.DD.YYYY')):'-'} -  
                                { record.effectiveEndTime?(dayjs(record.effectiveEndTime).format('MM.DD.YYYY')):'-'} 
                            </span>
                        </div>)
                    }
                },
                {
                    cnTitle: '备注',
                    dataIndex: 'remark',
                    cnTitleId: 'BeiZhu',
                    width:'200px',
                    render: (preLoadDate, record) =>{
                        return (<div className="remark-style">
                            {record.remark}
                        </div>)
                    }
                },
                {
                    cnTitle: '最后更新',
                    dataIndex: 'preLoadDate',
                    cnTitleId: 'ZuiHouGengXin',
                    render: (preLoadDate, record) =>{
                        return (<div>
                            <div>
                                {record.userName}
                            </div>
                            <div style={{color:'rgba(0,0,0,0.33)'}}>
                                {record.lastUpdateTime?(dayjs(record.lastUpdateTime).format('YYYY-MM-DD HH:mm:ss')):'-'}
                            </div>
                        </div>)
                    }
                },
                {
                    cnTitle: '操作',
                    dataIndex: 'CaoZuo',
                    width: 120,
                    cnTitleId: 'CaoZuo',
                    render: (item = {}, record) => (<Space>
                        <Popover content={Lang({id: 'BianJi',default:'编辑'})}>
                            <CertificateForm load={(e) => {
                                // window.location.reload()
                                this.onPageTemplateTableChild.handleFetch(1,{}, true);
                            }} id={record.id} options={[
                                {
                                    name:'categoryList',
                                    cnTitle:'适用类目',
                                    cnTitleId:'ShiYongLeiMu',
                                    type:'Category',
                                    getCateUrl:'/service/goods/public/category/query-catehory-list',
                                    required: true
                                },
                                {
                                    name:'code',
                                    cnTitle:'证书编号',
                                    cnTitleId:'ZhengShuBianHao',
                                    required: true
                                },
                                {
                                    name:'effectiveTime',
                                    cnTitle:'有效期',
                                    cnTitleId:'YouXiaoQi',
                                    type:'DateRangePicker',
                                    cnPlaceholder:[Lang({id:'KaiShiShiJian',default:'开始时间'}),Lang({id:'JieShuShiJian',default:'结束时间'})],
                                    cnPlaceholderId:['KaiShiShiJian','JieShuShiJian'],
                                    required: true
                                },
                                {
                                    name:'remark',
                                    cnTitle:'证书备注',
                                    cnTitleId:'ZhengShuBeiZhu',
                                    type:'TextArea',
                                    maxLength:255,
                                },

                                {
                                    name:'attachment',
                                    cnTitle:'证书文件',
                                    cnTitleId:'ZhengShuWenJian',
                                    maxCount:5,
                                    type:'UploadFile',
                                    // accept:'最多上传5张，小于10M .pdf, .jpg, .jpeg, .png',
                                    accept:'.pdf, .jpg, .jpeg, .png',
                                    cnPlaceholder: "最多上传5张,小于10M .pdf, .jpg, .jpeg, .png",
                                    cnPlaceholderId:"ZuiDuoShangChuan5Zhang",
                                    // flagLimitType:true,
                                    required: true
                                }
                            ]}>
                                <AuthBtn icon={"ri-edit-line"} tips = {Lang({id:"BianJi",default:"编辑"})}/>
                            </CertificateForm>
                        </Popover>
                        <AuthBtn icon={"ri-settings-4-line"}
                                 tips = {Lang({id:"ZhengShuGuaKao",default:"证书挂靠"})}
                                 linkTo={{
                                     // pathname: `/goods/certificate-attachment-rule/${record.id}`,
                                     pathname: '/goods/certificate-attachment-rule',
                                     search: `?${record.id}`,

                                 }}
                        />
                    </Space>)},
            ],
         }
     }
 
 
 
     componentDidMount() {
         // this.getData()
     }

     /**
     * 勾选 已过期 
     * */
     onChangeSelect(e){
        const {checked}= e.target;
        this.setState({
            isExpired:checked?1:''
        },()=> {
            this.onPageTemplateTableChild.handleFetch(1,{}, true);
        })
    }
    fetchBack(data={}){
        this.onRefPageCommonChild.isShowTop()
    }

    onRefTabOne = (ref) =>  this.onPageTemplateTableChild = ref;
    onRefPageCommon = (ref) => this.onRefPageCommonChild = ref;
    render() {

        let {loading, columns, searchFormOptions,isExpired} = this.state;
        const setLeftOne =(<div className={'textRight'}  style={{lineHeight: "32px"}}><Space>
            <Checkbox onChange={(e)=>this.onChangeSelect(e)}>{Lang({id:'YiGuoQi',default:'已过期'})}</Checkbox>
        </Space></div>);
         return (
            <PageCommon onRef={this.onRefPageCommon}>
                <Spin tip='loading' spinning={loading}>
                    <div className="CertificateMgr">
                        <CommonBreadcrumb list={[
                            {name: Lang({id: 'ZhengShuGuanLi', default: '证书管理'})}
                        ]}></CommonBreadcrumb>
                        
                        <div className="CertificateMgr-box">
                            <div className="CertificateMgr-header">
                                <span className="title">{ Lang({id: 'ZhengShuGuanLi', default: '证书管理'})} </span>
                                <CertificateForm load={(e) => {
                                    this.onPageTemplateTableChild.handleFetch(1,{}, true);
                                }} options={[
                                    {
                                        name:'categoryList',
                                        cnTitle:'适用类目',
                                        cnTitleId:'ShiYongLeiMu',
                                        type:'Category',
                                        getCateUrl:'/service/goods/public/category/query-catehory-list',
                                        required: true
                                    },
                                    {
                                        name:'code',
                                        cnTitle:'证书编号',
                                        cnTitleId:'ZhengShuBianHao',
                                        required: true
                                    },
                                    {
                                        name:'effectiveTime',
                                        cnTitle:'有效期',
                                        cnTitleId:'YouXiaoQi',
                                        type:'DateRangePicker',
                                        cnPlaceholder:[Lang({id:'KaiShiShiJian',default:'开始时间'}),Lang({id:'JieShuShiJian',default:'结束时间'})],
                                        cnPlaceholderId:['KaiShiShiJian','JieShuShiJian'],
                                        required: true
                                    },
                                    {
                                        name:'remark',
                                        cnTitle:'证书备注',
                                        cnTitleId:'ZhengShuBeiZhu',
                                        type:'TextArea',
                                        maxLength:255,
                                    },

                                    {
                                        name:'attachment',
                                        cnTitle:'证书文件',
                                        cnTitleId:'ZhengShuWenJian',
                                        maxCount:5,
                                        type:'UploadFile',
                                        // accept: Lang({id:'ZuiDuoShangChuan5Zhang',default:'最多上传5张,小于10M .pdf, .jpg, .jpeg, .png'}),
                                        accept:'.pdf, .jpg, .jpeg, .png',
                                        cnPlaceholder: "最多上传5张,小于10M .pdf, .jpg, .jpeg, .png",
                                        cnPlaceholderId:"ZuiDuoShangChuan5Zhang",
                                        // flagLimitType:true,
                                        required: true
                                    }
                                ]}>
                                    <Button type={'primary'}>{Lang({id: 'XinZengZhengShu', default: '新增证书'})}</Button>
                                </CertificateForm>

                            </div>
                            <div>
                            <AutoFetchTable columns={columns}
                                        onRef={this.onRefTabOne}
                                        flagShowReset={false}
                                        flagShowSearchBtn={false}
                                        topSearchLeftCont={setLeftOne}
                                        fetchCallBack={(data)=>this.fetchBack(data)}
                                        precondition={{isExpired:isExpired}} // 列表类型 	1: 预装列表 2:已出货列表
                                        searchFormOptions={searchFormOptions}
                                        rowKey={'code'}
                                        fetchApi={'/service/mg/certificate/query-list'} />
                            </div>
                        </div>
                    </div>
                </Spin>
            </PageCommon>


         )
     }
 }
 
 export default CertificateMgr
 